import React, { useEffect, useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { backend_url_img } from '../../api/server'
import { useTranslation } from 'react-i18next'
import toast from 'react-hot-toast'
import { useDispatch, useSelector } from 'react-redux'
import {
  add_to_card,
  add_to_wishlist,
  messageClear,
  get_card_products,
  get_wishlist,
} from '../../store/reducers/cardReducer'
import { getCurrentTime } from '../../utils/timeConvertor'
import { FaEye, FaHeart, FaRegHeart } from 'react-icons/fa'

const ShopProducts = ({ styles, products }) => {
  const { t, i18n } = useTranslation()
  const currentLanguage = i18n.language
  // const isRTL = currentLanguage === 'ar' || currentLanguage === 'kr'

  const dispatch = useDispatch()
  const navigate = useNavigate()
  const { userInfo } = useSelector((state) => state.auth)
  const { wishlist, errorMessage, successMessage } = useSelector(
    (state) => state.card
  )
  // const { currencyIQD } = useSelector((state) => state.dashboard)

  const [selectedPacks, setSelectedPacks] = useState({})

  useEffect(() => {
    if (products?.length) {
      const initialSelection = {}
      products.forEach((p) => {
        if (p.packs?.length > 0) {
          initialSelection[p._id] = p.packs[0]
        }
      })
      setSelectedPacks(initialSelection)
      dispatch(get_wishlist(userInfo?.id))
    }
  }, [products])

  const isFavorite = (productId) =>
    wishlist?.some((item) => item.productId._id === productId)

  const getProductName = (product) => {
    switch (currentLanguage) {
      case 'ar':
        return product?.arName
      case 'kr':
        return product?.kuName
      default:
        return product?.enName
    }
  }

  const handleAddToCart = (product, selectedPack) => {
    const createdAt = getCurrentTime()

    if (!userInfo) {
      navigate('/login')
      return
    }

    if (!selectedPack) return

    const payload = {
      userId: userInfo.id,
      productId: product._id,
      quantity: 1,
      packs: [
        {
          pack: selectedPack.pack,
          price: selectedPack.price,
          selected: true,
          properties: selectedPack.properties || [],
        },
      ],
      createdAt,
    }
dispatch(add_to_card(payload))
    
  }

  const add_wishlist = (product) => {
    const createdAt = getCurrentTime()
    if (!userInfo) {
      navigate('/login')
      return
    }


    const selectedPack = selectedPacks[product._id]

    const info = {
      userId: userInfo.id,
      productId: product._id,
      quantity: 1,
      packs: [selectedPack],
      createdAt: createdAt,
    }
 dispatch(add_to_wishlist(info))
   
  }

  useEffect(() => {
    if (successMessage) {
      toast.success(successMessage)
      dispatch(messageClear())
      dispatch(get_wishlist(userInfo?.id))
      dispatch(get_card_products(userInfo?.id))
    }
    if (errorMessage) {
      toast.error(errorMessage)
      dispatch(messageClear())
    }
  }, [successMessage, errorMessage, dispatch])

  return (
    <div
      className={`w-full grid ${
        styles === 'grid'
          ? 'grid-cols-5 md-lg:grid-cols-3 sm:grid-cols-2'
          : 'grid-cols-1 md-lg:grid-cols-2 sm:grid-cols-1'
      } gap-4 sm:gap-3 `}
    >
      {products?.map((p, i) => (
        <div key={i} className="block p-1">
          <div
            className={`relative group rounded-md border border-grey-200 hover:shadow-md pb-4 bg-white ${
              styles === 'grid'
                ? 'flex flex-col justify-start items-start'
                : 'flex flex-row items-center   p-4'
            }`}
          >
            <Link
              to={`/product/details/${p.slug}`}
              className={`relative group overflow-hidden ${
                styles === 'grid'
                  ? 'aspect-square w-full'
                  : 'w-[150px] h-[150px] flex-shrink-0 mr-4'
              }`}
            >
              <div className="absolute top-2 right-2 bg-white text-red-500 border border-red-500 text-xs font-bold w-6 h-6 rounded-full flex justify-center items-center z-10">
                18+
              </div>
              {/* {p.discount !== 0 && (
              <div className="absolute top-2 left-2 bg-red-500 text-white text-sm font-bold rounded-full w-10 h-10 flex items-center justify-center z-10">
                -{p.discount}%
              </div>
            )} */}
              <img
                className="w-full h-full object-contain cursor-pointer"
                src={`${backend_url_img}/${p.images[0]}`}
                alt={getProductName(p)}
              />
            </Link>

            {/* Product Details */}
            <div
              className={`${
                styles === 'grid'
                  ? 'w-full bg-gray-20 px-2'
                  : 'flex-1 flex flex-col'
              }`}
            >
              {/* Product Name */}
              <div
                className={`${
                  styles === 'grid' ? 'w-full border-b-[1px]' : 'mb-2'
                }`}
              >
                <Link to={`/product/details/${p.slug}`}>
                  <h2
                    className={`${
                      styles === 'grid'
                        ? 'text-sm font-normal py-3 overflow-hidden text-ellipsis whitespace-nowrap'
                        : 'text-md font-semibold'
                    }`}
                  >
                    {getProductName(p)}
                  </h2>
                </Link>
              </div>

              <div
                className={`${
                  styles === 'grid'
                    ? 'flex w-full flex-col gap-3'
                    : 'flex flex-col gap-3'
                }`}
              >
                {/* Pack Buttons */}
                <div
                  className={`${
                    styles === 'grid'
                      ? 'flex w-full items-center flex-col mt-3'
                      : ''
                  }`}
                >
                  <div className="flex items-start gap-2">
                    {p.packs?.map((pack, index) => {
                      const isSelected =
                        selectedPacks[p._id]?.pack?.code === pack.pack.code

                      return (
                        <button
                          key={index}
                          onClick={() =>
                            setSelectedPacks((prev) => ({
                              ...prev,
                              [p._id]: pack,
                            }))
                          }
                          className={`w-12 h-14 flex flex-col items-center justify-center border rounded-md text-sm font-semibold 
                      ${
                        isSelected
                          ? 'bg-[#B42A19] text-white'
                          : 'bg-gray-100 text-bg-primary border-gray-200'
                      }
                    `}
                        >
                          <span className="text-center">{pack.pack.code}</span>
                          <span className="text-center">
                            {getProductName(pack.pack)}
                          </span>
                        </button>
                      )
                    })}
                  </div>
                </div>

                <div
                  className={`flex justify-between items-center ${
                    styles === 'grid' ? 'mt-2' : ''
                  } text-sm font-semibold`}
                >
                  {/* Left side: discounted price */}
                  <span>
                    {selectedPacks[p._id]
                      ? new Intl.NumberFormat('en-US').format(
                          selectedPacks[p._id].price -
                            Math.floor(
                              (selectedPacks[p._id].price * p.discount) / 100
                            )
                        )
                      : ''}{' '}
                    {t('products.currency')}
                    {'/'}
                    {getProductName(p.packs?.[0].pack)}
                  </span>

                  <span>
                    {selectedPacks[p._id]
                      ? new Intl.NumberFormat('en-US').format(
                          selectedPacks[p._id].price *
                            selectedPacks[p._id].pack.code
                        )
                      : ''}
                  </span>
                </div>

                <div
                  className={`${
                    styles === 'grid'
                      ? 'flex w-full items-center flex-col mt-3'
                      : 'mt-2'
                  }`}
                >
                  <button
                    disabled={p.stock <= 0}
                    className={`px-3 py-2 rounded-full transition-colors duration-300 z-10
                                ${
                                  p.stock > 0
                                    ? 'bg-primary border border-gray-300 text-white hover:bg-darkRed hover:text-white'
                                    : 'bg-gray-400 border border-gray-300 text-gray-200 cursor-not-allowed'
                                }`}
                    onClick={() => handleAddToCart(p, selectedPacks[p._id])}
                  >
                    {t('products.add_to_card')}
                  </button>
                  <ul
                    className="
    absolute bottom-[-50px] left-0 sm:hidden
    w-full flex justify-between items-center px-2 gap-2
    opacity-0 group-hover:opacity-100 group-hover:bottom-4
    transition-all duration-500
  "
                  >
                    <li
                      onClick={() => add_wishlist(p)}
                      className={`w-[38px] h-[38px] cursor-pointer flex justify-center items-center border border-slate-300 rounded-full transition-all
      ${
        isFavorite(p._id)
          ? 'bg-red-100 text-darkRed'
          : 'bg-[#FBFBFB] hover:bg-darkRed hover:text-white'
      }
    `}
                    >
                      {isFavorite(p._id) ? <FaHeart /> : <FaRegHeart />}
                    </li>

                    <Link
                      to={`/product/details/${p.slug}`}
                      className="w-[38px] h-[38px] cursor-pointer flex justify-center items-center border bg-[#FBFBFB] rounded-full hover:bg-darkRed hover:text-white transition-all"
                    >
                      <FaEye />
                    </Link>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  )
}

export default ShopProducts
